import {
    IS_DEFINED,
    IS_NOT_EMPTY,
    IS_STRING,
    IS_BOOLEAN,
    IS_DATE_STRING,
    IS_ENUM,
    IS_EMAIL,
    ValidationArguments,
    IS_LENGTH,
} from '@lgce/class-validator';

const msgBuilder = (baseMsg: string | ((validationArgs: ValidationArguments) => string)) => {
    return (validationArguments: ValidationArguments): string => {
        const labels: Record<string, string> | undefined = (validationArguments.object as Record<string, unknown>)
            .labels as Record<string, string> | undefined;
        const propertyTranslated = labels && labels[validationArguments.property]
            ? labels[validationArguments.property]
            : validationArguments.property;
        const message = typeof baseMsg === 'string' ? baseMsg : baseMsg(validationArguments);
        return `${propertyTranslated}: ${message}`;
    };
};

export const validationMessages = {
    [IS_DEFINED]: 'champ requis',
    [IS_NOT_EMPTY]: 'ne peut être vide',
    [IS_STRING]: 'doit être une chaîne de caractères',
    [IS_BOOLEAN]: 'doit être une valeur booléenne (vrai/faux)',
    [IS_ENUM]: (validationArguments: ValidationArguments): string => {
        const enumObject = validationArguments.constraints[0] as Record<string, string>;
        const enumValues = Object.keys(enumObject).map((k) => enumObject[k]);
        return `doit avoir une valeur incluse dans cette liste: ${enumValues.join(',')}`;
    },
    [IS_DATE_STRING]: 'doit être une date au format ISO 8601',
    [IS_EMAIL]: 'doit être un email valide',
    [IS_LENGTH]: 'doit contenir au moins 8 caractères',
    isUnique: '$value existe déjà',
    isValidForSAPOfferType: `les déclenchements automatiques ne sont pas autorisés pour une offre SAP,
     veuillez les supprimer ou changer l'offre associée à cette programmation`,
    businessPasswordCheck: `doit contenir au moins 3 types de caractères parmis:
     chiffres, minuscules, majuscules, caractères spéciaux (!@#$%^&*)`,
    confirmPassword: 'doit être identique au mot de passe entré',
};

Object.keys(validationMessages).forEach((key: string) =>
    validationMessages[key] = msgBuilder(validationMessages[key]));
